import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { finalize } from 'rxjs/operators';
import { ContentTooltip } from 'src/app/models/content-tooltip';
import { Utils } from 'src/app/services/utils/utils.service';
import { environment } from '../../../environments/environment';
import { SAPDataService } from '../../services/sap/sap-data.service';
import { SharedStateService } from '../../services/shared-state/shared-state.service';

@Component({
    selector: 'app-enter-customer-details',
    templateUrl: './enter-customer-details.component.' + environment.brand + '.html',
    styleUrls: ['./enter-customer-details.component.' + environment.brand + '.css'],
    providers: [SAPDataService]
})
export class EnterCustomerDetailsComponent implements OnInit {
    customerDetailsForm: FormGroup;
    // idNumberValidationMessage = '';
    // get idNumberInvalid(): boolean { return this.idNumberValidationMessage != '' }
    // passportNumberValidationMessage = '';
    // get passportNumberInvalid(): boolean { return this.passportNumberValidationMessage != '' }
    identifierValidationMessage = '';
    get identifierInvalid(): boolean {
        return this.identifierValidationMessage !== '';
    }
    vinValidationMessage = '';
    get vinInvalid(): boolean { return this.vinValidationMessage != '' }
    transactionId: string;
    contentTooltips: ContentTooltip[] = [];

    constructor(private sharedStateService: SharedStateService,
        private sapDataService: SAPDataService,
        private route: ActivatedRoute,
        private router: Router,
        private utils: Utils) {
        this.utils.log('EnterCustomerDetailsComponent.constructor');
        const pageName = 'Enter Customer Details';

        // get and set tooltips
        this.contentTooltips = this.sharedStateService.contentTooltips.filter(x => x.pageName == pageName);
        if (this.contentTooltips.length == 0) {
            this.sharedStateService.onContentTooltipLoaded.subscribe(() => {
                this.contentTooltips = this.sharedStateService.contentTooltips.filter(x => x.pageName == pageName);
            });
        }
    }

    ngOnInit(): void {
        // // get transaction id which will be set if the user was directed here from a link
        // this.route.params.subscribe(params => {
        //     this.transactionId = params['transactionId'];
        //     this.utils.log('transactionId: ' + this.transactionId);
        // });

        // // create the form group
        // this.customerDetailsForm = new FormGroup({
        //     idNumber: new FormControl(''),
        //     passportNumber: new FormControl(''),
        //     vin: new FormControl('')
        // }, { validators: this.customValidationFunction });
        this.customerDetailsForm = new FormGroup({
            identifier: new FormControl(''),
            vin: new FormControl('')
        }, { validators: this.customValidationFunction });
    }

    /**
     * Custom validation function used because the user can enter id or passport number.
     **/
    private customValidationFunction: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
        // let errors = null;
        // const idNumber = control.get('idNumber');
        // const passportNumber = control.get('passportNumber');

        // if (idNumber.value.length == 0 && passportNumber.value.length == 0) {
        //     errors = { idOrPassportRequired: true };
        // } else {
        //     if (idNumber.value.length > 0 && new RegExp('^\\d{13}$').test(idNumber.value) == false) {
        //         errors = { ...errors, idNumberInvalid: true }
        //     }

        //     if (passportNumber.value.length > 0 && new RegExp('^(?!^0+$)[a-zA-Z0-9]{3,40}$').test(passportNumber.value) == false) {
        //         errors = { ...errors, passportNumberInvalid: true };
        //     }
        // }

        // const vin = control.get('vin');
        // if (vin.value?.length != 17) {
        //     errors = { ...errors, vinInvalid: true };
        // }

        // return errors;
        let errors = null;

        const identifier = control.get('identifier')?.value ?? '';
        const vin = control.get('vin')?.value ?? '';

        // ID or Passport
        if (identifier.trim().length === 0) {
            errors = {
                ...errors,
                identifierRequired: true
            };
        } else {
            const isValidId = /^\d{13}$/.test(identifier);
            const isValidPassport = /^(?!0+$)[a-zA-Z0-9]{3,40}$/.test(identifier);

            if (!isValidId && !isValidPassport) {
                errors = {
                    ...errors,
                    identifierInvalid: true
                };
            }
        }

        // VIN
        if (vin.length !== 17) {
            errors = {
                ...errors,
                vinInvalid: true
            };
        }

        return errors;
    };

    /**
     * Validate the user's input.
    **/
    onValidateInput(controlName: string, value: any): void {
        // if (value != null) {
        //     this.customerDetailsForm.controls[controlName].setValue(value.trimStart());
        // }

        // if (controlName == 'idNumber') {
        //     if (this.customerDetailsForm.errors?.idOrPassportRequired) {
        //         this.idNumberValidationMessage = 'Please enter your ID or Passport number';
        //     } else if (this.customerDetailsForm.errors?.idNumberInvalid) {
        //         this.idNumberValidationMessage = 'Please enter a valid ID number';
        //     } else {
        //         this.idNumberValidationMessage = '';
        //         this.passportNumberValidationMessage = '';
        //     }
        // }

        // if (controlName == 'passportNumber') {
        //     if (this.customerDetailsForm.errors?.idOrPassportRequired) {
        //         this.passportNumberValidationMessage = 'Please enter your ID or Passport number';
        //     } else if (this.customerDetailsForm.errors?.passportNumberInvalid) {
        //         this.passportNumberValidationMessage = 'Please enter a valid Passport number';
        //     } else {
        //         this.idNumberValidationMessage = '';
        //         this.passportNumberValidationMessage = '';
        //     }
        // }

        // if (controlName == 'vin') {
        //     if (this.customerDetailsForm.errors?.vinInvalid) {
        //         if (!value) { // only show message on blur
        //             this.vinValidationMessage = 'Please enter a valid VIN';
        //         }
        //     } else {
        //         this.vinValidationMessage = '';
        //     }
        // }

        if (value != null) {
            value = value.trim();
            this.customerDetailsForm.controls[controlName].setValue(value);
        }

        if (controlName === 'identifier') {
            if (this.customerDetailsForm.errors?.identifierRequired) {
                this.identifierValidationMessage =
                    'Please enter your ID or Passport number';
            } else if (this.customerDetailsForm.errors?.identifierInvalid) {
                this.identifierValidationMessage =
                    'Please enter a valid ID or Passport number';
            } else {
                this.identifierValidationMessage = '';
            }
        }

        if (controlName === 'vin') {
            if (this.customerDetailsForm.errors?.vinInvalid) {
                if (!value) {
                    this.vinValidationMessage = 'Please enter a valid VIN';
                }
            } else {
                this.vinValidationMessage = '';
            }
        }
    }

    onAuthenticateExistingCustomer(): void {
        // if (!this.customerDetailsForm.valid) {
        //     return;
        // }

        // const idNumber = this.customerDetailsForm.value.idNumber;
        // const passportNumber = this.customerDetailsForm.value.passportNumber.toUpperCase();
        // const vin = this.customerDetailsForm.value.vin.toUpperCase();

        // this.sharedStateService.toggleLoader(true);
        // this.sapDataService.getCustomerDetails(idNumber, passportNumber, '', vin)
        //     .pipe(finalize(() => { this.sharedStateService.toggleLoader(false) }))
        //     .subscribe(customerDetails => {
        //         if (customerDetails) {
        //             // set owner info
        //             customerDetails.authVin = vin;
        //             customerDetails.idNumber = idNumber;
        //             customerDetails.passportNumber = passportNumber;
        //             this.sharedStateService.setOwnerInfo(customerDetails);
        //             if (this.sharedStateService.selectedVehicleDetail) {
        //                 // user was directed here via 'just browsing'
        //                 this.sharedStateService.selectedVehicleDetail.vin = vin;
        //             }
        //             this.sharedStateService.saveState();
        //             // decide where to navigate to
        //             if (!this.transactionId) {
        //                 // normal login
        //                 this.sharedStateService.showCustomerDetails();
        //             } else {
        //                 // user was directed here via a link, re-use existing logic in payment redirect page
        //                 this.router.navigate(['/payment'], { queryParams: { transactionId: this.transactionId } });
        //             }
        //         } else {
        //             this.sharedStateService.showDialog({
        //                 isVisible: true,
        //                 header: 'No Data Found',
        //                 message: 'Please check your details or contact us for assistance.'
        //             });
        //             this.sharedStateService.enterCustomerDetailsErrorCount++;
        //         }
        //     }, error => {
        //         this.utils.log('onAuthenticateExistingCustomer', error);
        //         this.sharedStateService.showDialog({
        //             isVisible: true,
        //             header: 'Error validating details',
        //             message: 'Please check your details or contact us for assistance.'
        //         });
        //         this.sharedStateService.enterCustomerDetailsErrorCount++;
        //     });

        if (!this.customerDetailsForm.valid) {
            return;
        }

        const identifier = this.customerDetailsForm.value.identifier.trim();
        const vin = this.customerDetailsForm.value.vin.toUpperCase();

        this.sharedStateService.toggleLoader(true);

        this.sapDataService.getCustomerDetails(identifier, '', vin)
            .pipe(finalize(() => {
                this.sharedStateService.toggleLoader(false);
            }))
            .subscribe(customerDetails => {
                if (customerDetails) {
                    customerDetails.authVin = vin;

                    this.sharedStateService.setOwnerInfo(customerDetails);

                    if (this.sharedStateService.selectedVehicleDetail) {
                        this.sharedStateService.selectedVehicleDetail.vin = vin;
                    }

                    this.sharedStateService.saveState();

                    if (!this.transactionId) {
                        this.sharedStateService.showCustomerDetails();
                    } else {
                        this.router.navigate(['/payment'], {
                            queryParams: {
                                transactionId: this.transactionId
                            }
                        });
                    }
                } else {
                    this.sharedStateService.showDialog({
                        isVisible: true,
                        header: 'No Data Found',
                        message: 'Please check your details or contact us for assistance.'
                    });

                    this.sharedStateService.enterCustomerDetailsErrorCount++;
                }
            }, error => {
                this.utils.log('onAuthenticateExistingCustomer', error);

                this.sharedStateService.showDialog({
                    isVisible: true,
                    header: 'Error validating details',
                    message: 'Please check your details or contact us for assistance.'
                });

                this.sharedStateService.enterCustomerDetailsErrorCount++;
            });
    }

    onBack(): void {
        this.sharedStateService.showStart();
    }
}
